import { useContext, useMemo } from "react";
import { useRouter } from "next/router";
import { ModalV2 } from "components/V2/atoms/ModalV2/ModalV2";
import { TYPE_OF_FLOW_IN_GROUP } from "constants/variables";
import { useCommonContext } from "context/CommonDataContext";
import { screenContext } from "context/ScreenContext";
import { extractResource } from "helper/extractResource";

export interface CheckInEtihadBookingsProps {
  isOpen: boolean;
  onClose: () => void;
  flowType?: string;
}

export function CheckInEtihadBookings({ isOpen, onClose, flowType }: CheckInEtihadBookingsProps) {
  const { currentDevice } = useContext(screenContext);
  const { resources } = useCommonContext();
  const router = useRouter();
  const modalMessage = useMemo(() => {
    if (flowType === TYPE_OF_FLOW_IN_GROUP.MY_BOOKING) {
      return extractResource(resources, "etihadManageBookingInfo");
    }

    if (router.asPath === "/add-ons/travel-certificate") {
      return extractResource(resources, "travelCertificateCodeShareMessage");
    }

    return extractResource(resources, "etihadCheckInInfo");
  }, [flowType, router.asPath, resources]);

  return (
    <ModalV2
      isFullWidth
      scrollable={true}
      isOpen={isOpen}
      onClose={onClose}
      className=""
      modalTitle={extractResource(resources, "importantInformation")}
      showBorderRadius={true}
      size="sx"
      setModalBottom={true}
      showDivider
      contentStyle={{
        top: `${currentDevice === "mobile" ? "auto" : "50%"}`,
        left: `${currentDevice === "mobile" ? "50%" : "50%"}`,
        right: `${currentDevice === "mobile" ? "auto" : "auto"}`,
        bottom: `${currentDevice === "mobile" ? "0" : "auto"}`,
        transform: `${currentDevice === "mobile" ? "translate(-50%, 0)" : "translate(-50%, -50%)"}`,
        position: "absolute"
      }}
    >
      <div className="flex justify-center items-center pl-5 h-28" dangerouslySetInnerHTML={{ __html: modalMessage }} />
    </ModalV2>
  );
}

export default CheckInEtihadBookings;
